import onThemeChange from './on-theme-change';
import onLanguageChange from './on-language-change';
import onSignOut from './on-sign-out';
import onClick2Call from './on-click-2-call';
import onBroadCastMessageReceived from './on-broadcast-message-received';
var eventSubscriber = {
  onThemeChange: onThemeChange,
  onLanguageChange: onLanguageChange,
  onSignOut: onSignOut,
  onClick2Call: onClick2Call,
  onBroadCastMessageReceived: onBroadCastMessageReceived
};
export default eventSubscriber;